import React from 'react';

import DataBrowser from 'components/core/DataBrowser'
import useDataBrowser from 'hooks/useDataBrowse'

import PatientDeviceDialog from 'components/PatientDeviceDialog'
import { dynamicDialogHelper } from 'utils'

const columnsOverride = [{
    type: 'AvatarColumn',
    dataKey: 'largeImage',
    columnText: 'device',
    order: 1,
    width: 10
}, {
    dataKey: 'modelNo',
    order: 2
}, {
    dataKey: 'device',
    order: 3
}, {
    dataKey: 'serialNumber',
    order: 4
}]

const actionsOverride = [{
    type: 'scan',
    component: dynamicDialogHelper({ id: 'Scan', multiEntry: true, resetOnSubmit: true}),
    keepOpened: true, // Needed for DataBrowser handling when to close the Dialog
    order: 2
}, {
    type: 'assignKit',
    component: dynamicDialogHelper({ id: 'AssignKit', submitOnEnter: true, resetOnSubmit: true }),
    order: 1
}, {
    type: 'create',
    component: PatientDeviceDialog,
    order: 3
}, {
    type: 'delete',
    disabled: selection => (selection.length === 0),
    selectionMap: ({ deviceId, serialNumber }) => ({ deviceId, serialNumber }),
    confirm: true,
    order: 4
}]

const PatientDevices = ({ actions, columns, resources, ...others }) => {
    const { actionsState, columnsState, dataState, handleRefresh, handleAction, isLoading, inProgress } = useDataBrowser([actionsOverride], [columnsOverride], {
        actions, 
        columns, 
        resources
    })

    return (
        <DataBrowser
			//statefulId="patient-devices"
            actions={actionsState}
            columns={columnsState}
            rows={dataState}
            searchFieldName={['device']}
            onRefresh={handleRefresh}
            onAction={handleAction}
            isLoading={isLoading}
            inProgress={inProgress}
            {...others}
        />
    )
}

export default PatientDevices